import { Layout } from "antd";

import { Route, Routes, useRoutes } from "react-router-dom";

// File Imports --
import PageNotFound from "../404/404Error";

import Dashboard from "../home/Dashboard";

import Login from "../auth/Login";
import Drawer from "../inc/Drawer";
import "../../App.css";
import FilesManager from "../images/FilesManager";
import CategoryAdd from "../category/CategoryAdd";
import CategoryTable from "../category/CategoryTable";
import CategoryUpdate from "../category/CategoryUpdate";
import PagesTable from "../pages/PagesTable";
import PagesAdd from "../pages/PagesAdd";
import PagesUpdate from "../pages/PagesUpdate";
import SliderTable from "../slider/SliderTable";
import SliderAdd from "../slider/SliderAdd";
import SliderUpdate from "../slider/SliderUpdate";
import CustomerTable from "../customer/CustomerTable";
import CustomerAdd from "../customer/CustomerAdd";
import CustomerUpdate from "../customer/CustomerUpdate";
import UserTable from "../user/UserTable";
import UserAdd from "../user/UserAdd";
import UserUpdate from "../user/UserUpdate";
import Setting from "../setting/Setting";
import ProductTable from "../product/ProductTable";
import ProductAdd from "../product/ProductAdd";
import ProductUpdate from "../product/ProductUpdate";
import TestimonialTable from "../testimonial/TestimonialTable";
import TestimonialAdd from "../testimonial/TestimonialAdd";
import TestimonialUpdate from "../testimonial/TestimonialUpdate";
import ContactTable from "../contact/ContactTable";
import PopupTable from "../popup/PopupTable";
import PopupAdd from "../popup/PopupAdd";
import PopupUpdate from "../popup/PopupUpdate";
import BrandTable from "../brand/BrandTable";
import BrandAdd from "../brand/BrandAdd";
import BrandUpdate from "../brand/BrandUpdate";
import SubCategoryTable from "../sub_category/SubCategoryTable";
import SubCategoryAdd from "../sub_category/SubCategoryAdd";
import SubCategoryUpdate from "../sub_category/SubCategoryUpdate";
import CouponTable from "../coupon/CouponTable";
import CouponAdd from "../coupon/CouponAdd";
import CouponUpdate from "../coupon/CouponUpdate";
import ProductInventoryTable from "../product/ProductInventoryTable";
import OrderTable from "../order/OrderTable";
import OrderDetail from "../order/OrderDetail";
import OrderCancelTable from "../order/OrderCancelTable";
import OrderDeliveredTable from "../order/OrderDeliveredTable";
import OrderShippedTable from "../order/OrderShippedTable";
import OrderAcceptTable from "../order/OrderAcceptTable";
import ProfileUpdate from "../profile/ProfileUpdate";
const Base = () => {
  const match = useRoutes([
    { path: "/order-invoice/:id", element: null }, // No sidebar for this route
    { path: "/login", element: null }, // No sidebar for this route
    { path: "*", element: <Drawer /> }, // Render sidebar for other routes
  ]);

  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      {match}

      {/* Routes */}

      <Routes>
        <Route path="*" element={<PageNotFound />} />

        <Route path="/" element={<Dashboard />} />

        <Route path="/login" element={<Login />} />

        <Route path="/file-manager" element={<FilesManager />} />

        <Route path="/slider" element={<SliderTable />} />
        <Route path="/slider/add" element={<SliderAdd />} />
        <Route path="/slider/edit/:id" element={<SliderUpdate />} />

        <Route path="/popup" element={<PopupTable />} />
        <Route path="/popup/add" element={<PopupAdd />} />
        <Route path="/popup/edit/:id" element={<PopupUpdate />} />

        <Route path="/brand" element={<BrandTable />} />
        <Route path="/brand/add" element={<BrandAdd />} />
        <Route path="/brand/edit/:id" element={<BrandUpdate />} />

        <Route path="/category" element={<CategoryTable />} />
        <Route path="/category/add" element={<CategoryAdd />} />
        <Route path="/category/edit/:id" element={<CategoryUpdate />} />

        <Route path="/sub-category" element={<SubCategoryTable />} />
        <Route path="/sub-category/add" element={<SubCategoryAdd />} />
        <Route path="/sub-category/edit/:id" element={<SubCategoryUpdate />} />

        <Route path="/testimonial" element={<TestimonialTable />} />
        <Route path="/testimonial/add" element={<TestimonialAdd />} />
        <Route path="/testimonial/edit/:id" element={<TestimonialUpdate />} />

        <Route path="/coupon" element={<CouponTable />} />
        <Route path="/coupon/add" element={<CouponAdd />} />
        <Route path="/coupon/edit/:id" element={<CouponUpdate />} />

        <Route path="/pages" element={<PagesTable />} />
        <Route path="/pages/add" element={<PagesAdd />} />
        <Route path="/pages/edit/:id" element={<PagesUpdate />} />

        <Route path="/customer" element={<CustomerTable />} />
        <Route path="/customer/add" element={<CustomerAdd />} />
        <Route path="/customer/edit/:id" element={<CustomerUpdate />} />

        <Route path="/contacts" element={<ContactTable />} />

        <Route path="/user" element={<UserTable />} />
        <Route path="/user/add" element={<UserAdd />} />
        <Route path="/user/edit/:id" element={<UserUpdate />} />

        <Route path="/profile/update" element={<ProfileUpdate />} />

        <Route path="/product" element={<ProductTable />} />
        <Route path="/product-inventory" element={<ProductInventoryTable />} />
        <Route path="/product/add" element={<ProductAdd />} />
        <Route path="/product/edit/:id" element={<ProductUpdate />} />

        <Route path="/order" element={<OrderTable />} />
        <Route path="/order/canceled" element={<OrderCancelTable />} />
        <Route path="/order/delivered" element={<OrderDeliveredTable />} />
        <Route path="/order/shipped" element={<OrderShippedTable />} />
        <Route path="/order/accept" element={<OrderAcceptTable />} />
        <Route path="/order/view/:id" element={<OrderDetail />} />

        <Route path="/setting" element={<Setting />} />
      </Routes>
    </Layout>
  );
};

export default Base;
